/**
 * Ein Suchtreffer fuehrt direkt zum Eintrag (F-18): Seiten per Link,
 * Aufgaben in den Aufgaben-Dialog, Termine in den Kalender - beim naechsten
 * Vorkommen, sonst am Tag des Termins, und dort geoeffnet.
 */
import { useNavigate } from 'react-router-dom';

import { getOccurrences } from '@/db/repositories/events';
import { useTaskDialog } from '@/modules/tasks/taskDialogStore';
import { useCalendarStore } from '@/store/calendar';
import { useUiStore } from '@/store/ui';
import { addDays, datePart, today } from '@/lib/datetime';
import type { SuchZiel } from '@/domain/suche';
import type { ID, LocalDate, LocalDateTime } from '@/domain/types';

export function useTrefferOeffnen(): (ziel: SuchZiel) => void {
  const navigate = useNavigate();
  const aufgabeOeffnen = useTaskDialog((s) => s.open);
  const setView = useUiStore((s) => s.setCalendarView);
  const setAnchor = useCalendarStore((s) => s.setAnchor);
  const select = useCalendarStore((s) => s.select);

  async function termin(eventId: ID, datum: LocalDate) {
    const suche = async (von: LocalDate, tage: number) => (await getOccurrences({
      from: `${von}T00:00` as LocalDateTime, to: `${addDays(von, tage)}T00:00` as LocalDateTime,
    })).filter((o) => o.eventId === eventId).sort((a, b) => String(a.start).localeCompare(String(b.start)))[0];
    const vorkommen = (await suche(today(), 366)) ?? (await suche(datum, 1));
    setView('tag');
    setAnchor(vorkommen ? datePart(String(vorkommen.start) as LocalDate) : datum);
    if (vorkommen) select(vorkommen);
    navigate('/kalender');
  }

  return (ziel) => {
    if ('pfad' in ziel) navigate(ziel.pfad);
    else if ('aufgabe' in ziel) aufgabeOeffnen(ziel.aufgabe);
    else void termin(ziel.termin, ziel.datum);
  };
}
